{
  "columns": [
    {
      "header_id": "serviceCode",
      "header_label": "Service Code",
      "jsonpath": "serviceCode",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "rate",
      "header_label": "Rate",
      "jsonpath": "rate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "orgName",
      "header_label": "Regional Center",
      "jsonpath": "orgName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "fromDate",
      "header_label": "From Date",
      "jsonpath": "fromDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "toDate",
      "header_label": "To Date",
      "jsonpath": "toDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "countyName",
      "header_label": "County",
      "jsonpath": "countyName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "cityName",
      "header_label": "City",
      "jsonpath": "cityName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "stateName",
      "header_label": "State",
      "jsonpath": "stateName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    }
  ],
  "buttons": [],
  "apiDetails": "list_payable_personal_assistant_rates.json",
  "pageName": "pa-rate-list",
  "orderByColumn": ["payRateId"],
  "orderBy": ["desc"]
}
